import { render, staticRenderFns } from "./loader-full.html?vue&type=template&id=b9a52b2a&scoped=true&external"
import script from "./loader-full.js?vue&type=script&lang=js&external"
export * from "./loader-full.js?vue&type=script&lang=js&external"
import style0 from "./loader-full.scss?vue&type=style&index=0&id=b9a52b2a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a52b2a",
  null
  
)

export default component.exports